import { getNextPageUrl, pagination } from "../../../helpers/store";
import axios from "axios";
import { API_HOST } from "../../../config/app-const";
import { cloneDeep } from "lodash";
import timeDelay from "../../../helpers/timeDelay";

const filters = {
  sort: 'desc',
  order: 'created_at',
  name: '',
}

const state = {
  queryRules: {
    data: [],
    isBusy: false,
    isDeleting: false,
    isInitiated: false,
    pagination: cloneDeep(pagination),
    filters: cloneDeep(filters),
    error: null
  },

  queryRule: {
    data: {},
    isBusy: false,
    error: null,
  },

  impression: {
    isBusy: false,
    error: null,
  }
}

const mutations = {
  SET_QUERY_RULES_BUSY(state, payload) {
    state.queryRules.isBusy = payload;
  },
  SET_QUERY_RULE_BUSY(state, payload) {
    state.queryRule.isBusy = payload;
  },
  SET_QUERY_RULES_DELETE_BUSY(state, payload) {
    state.queryRules.isDeleting = payload;
  },
  SET_QUERY_RULES_INITIATE_STATE(state, payload) {
    state.queryRules.isInitiated = payload;
  },
  SET_QUERY_RULES_SEARCH_QUERY(state, payload) {
    state.queryRules.filters.name = payload;
  },
  SET_PAGINATED_RESOURCE(state, {key, resourceData, pagination:responsePagination, reset = false}) {
    if(reset) {
      state[key].isInitiated = false
      state[key].data = []
      state[key].pagination = {...pagination}
    }
    resourceData.forEach(query => state[key].data.push({...query, isSelected: false}))
    state[key].pagination = { ...state[key].pagination, ...responsePagination }
    state[key].isInitiated = true
  },
  RESET_PAGINATED_RESOURCE(state, key) {
    state[key].isInitiated = false
    state[key].isBusy = false
    state[key].data = []
    state[key].pagination = cloneDeep(pagination),
    state[key].filters = cloneDeep(filters)
  },
  RESET_PAGINATED_RESOURCE_PAGINATION(state, key) {
    state[key].pagination = cloneDeep(pagination)
  },
  RESET_PAGINATED_RESOURCE_FILTERS(state, key) {
    state[key].filters = cloneDeep(filters)
  },
  SET_QUERY_RULE(state, payload = {}) {
    state.queryRule.data = payload;
    for (let i = 0, l = state.queryRules.data.length; i < l; ++i) {
      if (state.queryRules.data[i].id == payload.id) {
        state.queryRules.data[i].name = payload.name;
      }
    }
  },
  DELETE_QUERY_RULE(state, id) {
    state.queryRules.data = state.queryRules.data.filter(queryRule => queryRule.id !== id)
  },
  SELECT_QUERY_RULE(state, id) {
    const queryRule = state.queryRules.data.find(queryRule => queryRule.id === id)
    queryRule.isSelected = !queryRule.isSelected
  },
  SET_VALIDATE_IMPRESSION_BUSY(state, payload) {
    state.impression.isBusy = payload;
  },
  SET_VALIDATE_IMPRESSION(state, payload = {}) {
    if (payload && payload.error == true) {
      state.impression.error = payload.message;
    } else {
      state.impression.error = null;
    }
  }
}

const actions = {
  getPaginatedResource({commit, rootState}, {key = 'queryRules', url }) { // key is the resource you update in this file (e.g. "searches", "group_library", "outlets" - paginated resource)
    let { page, total_pages, per_page } = state[key].pagination
    const localPagination = {page, per_page}
    const { filters } = state[key]
    const start = Date.now()

    return new Promise((resolve, reject) => {

      if (page && page >= total_pages) reject()

      commit('SET_QUERY_RULES_BUSY', true)

      const { accessToken } = rootState.user.user.data;
      const config = { headers: { Authorization: `Token token=${accessToken}` } };

      axios.get(API_HOST + getNextPageUrl(url, localPagination, filters), config)
        .then(async ({data: {data: {data: resourceData, pagination}}}) => {

          // reset pagination response to snake_case format
          pagination = {
            page: pagination.currentPage,
            total_count: pagination.totalCount,
            total_pages: pagination.totalPages,
            per_page: pagination.perPage || per_page
          }
          await timeDelay(start, 250)
          commit('SET_QUERY_RULES_INITIATE_STATE', true)
          commit('SET_QUERY_RULES_BUSY', false)
          commit("SET_PAGINATED_RESOURCE", {key, resourceData, pagination, reset: pagination.page === 1})
          resolve()
        })
        .catch((e) => {
          commit('SET_QUERY_RULES_BUSY', false)
          reject(e)
        });
    })
  },

  getQueryRule({commit, rootState}, { url }) {
    return new Promise((resolve, reject) => {
      commit('SET_QUERY_RULE_BUSY', true)
      const { accessToken } = rootState.user.user.data;
      const config = { headers: { Authorization: `Token token=${accessToken}` } };
      axios.get(API_HOST + `${url}`, config)
        .then(({ data = {} }) => {
          commit("SET_QUERY_RULE", data)
          resolve(data)
        })
        .catch((e) => reject(e))
        .finally(function() {
          commit('SET_QUERY_RULE_BUSY', false);
        })
    })
  },

  createQueryRule({commit, rootState}, { url, data }) {
    return new Promise((resolve, reject) => {
      commit('SET_QUERY_RULE_BUSY', true)
      const { accessToken } = rootState.user.user.data;
      const config = { headers: { Authorization: `Token token=${accessToken}` } };
      axios.post(API_HOST + `${url}`, data, config)
        .then(({ data = {} }) => {
          commit("SET_QUERY_RULE", data)
          resolve(data)
        })
        .catch(function(e) {
          if (e && e.response && e.response.data && e.response.data.error && e.response.data.error.message) {
            reject(new Error("Request failed with status code " + (e.response.data.error.status || 500) + ": " + e.response.data.error.message));
          } else {
            reject(e)
          }
        })
        .finally(function() {
          commit('SET_QUERY_RULE_BUSY', false);
        });
    });
  },

  updateQueryRule({commit, rootState}, { url, data }) {
    return new Promise((resolve, reject) => {
        commit('SET_QUERY_RULE_BUSY', true)
        const { accessToken } = rootState.user.user.data;
        const config = { headers: { Authorization: `Token token=${accessToken}` } };
        axios.put(API_HOST + `${url}`, data, config)
          .then(({ data = {} }) => {
            commit("SET_QUERY_RULE", data)
            resolve(data)
          })
          .catch(function(e) {
            if (e && e.response && e.response.data && e.response.data.error && e.response.data.error.message) {
              reject(new Error("Request failed with status code " + (e.response.data.error.status || 500) + ": " + e.response.data.error.message));
            } else {
              reject(e)
            }
          })
          .finally(function() {
            commit('SET_QUERY_RULE_BUSY', false);
          });
    });
  },

  deleteQueryRule({commit, rootState}, {url }) {
    return new Promise((resolve, reject) => {
      commit('SET_QUERY_RULES_DELETE_BUSY', true)
      const { accessToken } = rootState.user.user.data;
      const config = { headers: { Authorization: `Token token=${accessToken}` } };
      axios.delete(API_HOST + `/${url}`, config)
        .then(({ data }) => {
          commit('DELETE_QUERY_RULE', data.id)
          resolve()
        })
        .catch(function(e) {
          if (e && e.response && e.response.data && e.response.data.error && e.response.data.error.message) {
            reject(new Error("Request failed with status code " + (e.response.data.error.status || 500) + ": " + e.response.data.error.message));
          } else {
            reject(e)
          }
        })
        .finally(() => commit('SET_QUERY_RULES_DELETE_BUSY', false))
    })
  },

  deleteBulkQueryRules({commit, rootState}, { url, data }) {
    return new Promise((resolve, reject) => {
      commit('SET_QUERY_RULES_DELETE_BUSY', true)
      const { accessToken } = rootState.user.user.data;
      const config = {
        headers: {
          Authorization: `Token token=${accessToken}`,
          'Content-Type': 'application/json',
        },
        data
      };
      axios.delete(API_HOST + `/${url}`, config)
        .then(({ data }) => {
          data.forEach(id => commit('DELETE_QUERY_RULE', id))
          resolve()
        })
        .catch(function(e) {
          if (e && e.response && e.response.data && e.response.data.error && e.response.data.error.message) {
            reject(new Error("Request failed with status code " + (e.response.data.error.status || 500) + ": " + e.response.data.error.message));
          } else {
            reject(e)
          }
        })
        .finally(() => commit('SET_QUERY_RULES_DELETE_BUSY', false))
    })
  },

  validateImpression({commit, rootState}, { url, data }) {
    return new Promise((resolve, reject) => {
      commit('SET_VALIDATE_IMPRESSION_BUSY', true)
      const { accessToken } = rootState.user.user.data;
      const config = { headers: { Authorization: `Token token=${accessToken}` } };
      axios.post(API_HOST + `${url}`, data, config)
        .then(({ data = {} }) => {
          commit("SET_VALIDATE_IMPRESSION", data)
          resolve(data)
        })
        .catch(function(e) {
          if (e && e.response && e.response.data && e.response.data.error && e.response.data.error.message) {
            reject(new Error("" + e.response.data.error.message));
          } else {
            reject(e)
          }
        })
        .finally(function() {
          commit('SET_QUERY_RULE_BUSY', false);
        });
  });
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};